import { render, staticRenderFns } from "./CurrentTable.vue?vue&type=template&id=a6759f70&"
import script from "./CurrentTable.vue?vue&type=script&lang=js&"
export * from "./CurrentTable.vue?vue&type=script&lang=js&"
import style0 from "./CurrentTable.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports